import { AccordionItemConfigProps } from 'molecules/Accordion/config';

// Accordions whose heading/eyebrow reads as an FAQ section (the "Common
// Questions" blocks the D&D audit flagged) should carry FAQPage schema even
// when an editor never flipped the per-instance `hasFaqSchema` toggle. Items
// are already Q&A pairs by config (label = question, richText = answer), so a
// FAQ-titled accordion is genuine FAQPage content. Detecting it in code covers
// the 15 content pages + 12 solutions pages without per-page Builder edits.
const FAQ_HEADING = /\b(faqs?|common questions|frequently asked|q&a|questions answered)\b/i;

export const isFaqSection = (...headings: (string | null | undefined)[]): boolean =>
  headings.some(heading => !!heading && FAQ_HEADING.test(heading));

export const getFaqSchema = (accordionItems: AccordionItemConfigProps[], schemaName?: string | null) => {
  const Accordion = accordionItems.map(faq => ({
    '@type': 'Question',
    name: faq?.label || '',
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.description || '',
    },
  }));

  return {
    name: schemaName || 'Frequently Asked Questions',
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: Accordion,
  };
};
